export const duProvisioning = 'http://du.dev.24orepro.in.ilsole24ore.it';
export const duHost = 'https://du.ilsole24ore.com/du';
export const duHostUsers = 'https://du.ilsole24ore.com/utenti';
export const paywallDomain = 'https://abbonamenti-dlv.ilsole24ore.com';
export const soleproDomain = 'https://24orepro-dlv.ilsole24ore.com';
export const usersDu = 'https://api24.ilsole24ore.com/Users';
export const my25Services = 'https://areautente.ilsole24ore.com/my24services/Services';